import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

function AdminLogin({ setUser, adminEmail, adminPassword }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    if (email === adminEmail && password === adminPassword) {
      setUser({ role: "admin", email: adminEmail });
      navigate("/admin-dashboard");
    } else {
      setError("Invalid admin credentials. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/toutmate_logo_transparent.png"
          alt="ToutMate Logo"
          className="login-logo"
        />
        <h2>Admin Login</h2>
        <form onSubmit={handleLogin}>
          <div className="input-container">
            <label htmlFor="email" className="sr-only">
              Admin Email
            </label>
            <input
              id="email"
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
            />
          </div>
          <div className="input-container">
            <label htmlFor="password" className="sr-only">
              Admin Password
            </label>
            <input
              id="password"
              type="password"
              placeholder="Admin Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="login-button">
            Login as Admin
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
